import type { PracticeProfileResponse } from "../../../lib/api-types/schemas";
import { ApiError } from "@/lib/api-client/authenticatedClient";
import { getApiPracticesPracticeId } from "@/lib/api-client/endpoints/practice/practice";

export class PracticeLookupError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

export async function fetchPracticeByClinicId(
  clinicId: string,
  accessToken: string,
) {
  try {
    const response = await getApiPracticesPracticeId(clinicId, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.data as PracticeProfileResponse;
  } catch (error) {
    if (error instanceof ApiError) {
      throw new PracticeLookupError(
        error.status,
        error.message || "Unable to fetch practice details.",
      );
    }

    if (error instanceof Error) {
      throw new PracticeLookupError(500, error.message);
    }

    throw new PracticeLookupError(500, "Unable to fetch practice details.");
  }
}

export const fetchPracticeByTenantId = fetchPracticeByClinicId;
